module.exports = __webpack_public_path__ + "assets/FigureStyles.43596525050ddaecfc07187f22d7a592.xml";


//////////////////
// WEBPACK FOOTER
// ./src/resources/FigureStyles.xml
// module id = 876
// module chunks = 0